<div class="chat-shell d-flex">

  <aside class="chat-sidebar d-flex flex-column" *ngIf="showConversationHistory">
    <div class="chat-sidebar__header">
      <button type="button" class="chat-new-btn" (click)="newConversation()">
        + {{ 'GLIPPY_NEW_CONVERSATION' | translate }}
      </button>
    </div>
    <div class="chat-sidebar__label">{{ 'GLIPPY_HISTORY' | translate }}</div>
    <div class="chat-sidebar__list flex-grow-1 overflow-auto" role="list">
      <button
        *ngFor="let conversation of conversations"
        type="button"
        role="listitem"
        class="chat-conversation"
        [class.chat-conversation--active]="conversation.id === conversationId"
        (click)="selectConversation(conversation)"
      >
        <span class="chat-conversation__title">{{ conversation.title }}</span>
        <span class="chat-conversation__date">{{ conversation.updatedAt | date: 'd MMM y' }}</span>
      </button>
    </div>
  </aside>

  <div class="chat-layout d-flex flex-column flex-grow-1">

    <div class="flex-grow-1 overflow-auto message-list" aria-live="polite" aria-label="Chat messages" #messageList>
      <div class="message-spacer"></div>
      <ng-container *ngFor="let msg of messages">
        <div
          *ngIf="hasContent(msg)"
          class="message-row d-flex"
          [class.justify-content-end]="msg.role === 'user'"
        >
          <div
            class="message-bubble"
            [class.message-bubble--user]="msg.role === 'user'"
            [class.message-bubble--assistant]="msg.role === 'assistant'"
            [class.message-bubble--errored]="msg.errored"
          >
            <ng-container *ngIf="msg.role === 'user'">
              <span *ngFor="let seg of msg.segments" style="white-space: pre-wrap;">
                <ng-container *ngIf="seg.type === 'text'">{{ seg.text }}</ng-container>
              </span>
            </ng-container>
            <ng-container *ngIf="msg.role === 'assistant'">
              <ng-container *ngFor="let seg of msg.segments">
                <div *ngIf="seg.type === 'text'" class="markdown-body" [innerHTML]="toHtml(seg.text)"></div>
                <gung-glippy-table *ngIf="seg.type === 'table'" [data]="seg.data"></gung-glippy-table>
                <gung-glippy-chart *ngIf="seg.type === 'chart'" [data]="seg.data"></gung-glippy-chart>
                <gung-glippy-product-suggestion *ngIf="seg.type === 'product-suggestion'" [data]="seg.data"></gung-glippy-product-suggestion>
              </ng-container>
            </ng-container>
            <span *ngIf="msg.refusedReason" class="message-refused">{{ refusedKey(msg) | translate }}</span>
            <small *ngIf="msg.errored" class="d-block message-error mt-1">{{ 'GLIPPY_ERROR_RETRY' | translate }}</small>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="waiting-pill-row" *ngIf="waiting" aria-label="Waiting for response" aria-live="polite">
      <div class="waiting-pill">
        <span class="dot" aria-hidden="true"></span>
        <span class="dot" aria-hidden="true"></span>
        <span class="dot" aria-hidden="true"></span>
      </div>
    </div>

    <div class="chat-input-row">
      <div class="chat-composer">
        <input
          type="text"
          class="chat-input"
          [(ngModel)]="inputValue"
          [attr.disabled]="streaming ? true : null"
          (keyup.enter)="send()"
          [placeholder]="'GLIPPY_PLACEHOLDER' | translate"
        />
        <button
          *ngIf="!streaming"
          type="button"
          class="chat-send-btn"
          (click)="send()"
          [disabled]="!inputValue.trim()"
        >
          {{ 'SEND' | translate }}
        </button>
        <button
          *ngIf="streaming"
          type="button"
          class="chat-stop-btn"
          (click)="stop()"
        >
          {{ 'STOP' | translate }}
        </button>
      </div>
    </div>

  </div>

</div>
